import {
  useContactAPIOperationsProperties
} from 'src/pages/SharedPageCustomHooks/UseContactsSavePropertiesPage/useContactAPIOperationsProperties';
import { IContactFormData } from 'src/SharedCustomHooks/UseContactFormData/types';

interface UseContactFormSubmissionPropertiesOptions {
  propertyId: string;
  adminContactId?: string;
  editingExistingContactInTable?: boolean;
  appendingNewContactToExistingProperty?: boolean;
  onSuccess?: () => void;
  onClose?: () => void;
  onRefreshDevelopers?: (propertyId: any) => Promise<void>;
}

interface UseContactFormSubmissionPropertiesReturn {
  handleSubmitContactForm: (
    formData: IContactFormData,
    formType: string
  ) => Promise<void>;
  isLoading: boolean;
}

export const useContactFormSubmissionProperties = ({
  propertyId,
  adminContactId,
  editingExistingContactInTable = false,
  appendingNewContactToExistingProperty = false,
  onSuccess,
  onClose,
  onRefreshDevelopers
}: UseContactFormSubmissionPropertiesOptions): UseContactFormSubmissionPropertiesReturn => {
  const {
    onCreateContact,
    onEditContact,
    isLoading,
    addExistingUserToProperty,
  } = useContactAPIOperationsProperties();
  
  const handleSubmitContactForm = async (
    formData: IContactFormData,
    formType: string
  ): Promise<void> => {
    try {
      let submissionSuccess: boolean;
      
      // Properties page logic: Handle different submission flows.
      if (formType === 'Existing') {
        // Adding existing Property Developer/Service Manager to property.
        if (!adminContactId) {
          console.error('adminContactId is required for adding existing users');
          return;
        }
        
        submissionSuccess = await addExistingUserToProperty(
          formData,
          propertyId,
          adminContactId
        );
      } else if (formData.id) {
        submissionSuccess = await onEditContact(
          formData,
          propertyId,
          editingExistingContactInTable,
          appendingNewContactToExistingProperty
        );
      } else {
        submissionSuccess = await onCreateContact(
          formData,
          propertyId,
          appendingNewContactToExistingProperty
        );
      }
      
      if (submissionSuccess) {
        onSuccess?.();

        if (onRefreshDevelopers) {
          await onRefreshDevelopers(propertyId);
        }
      }
      
      onClose?.();
    } catch (error) {
      console.error('Contact form submission failed:', error);
    }
  };
  
  return {
    handleSubmitContactForm,
    isLoading,
  };
};